import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface WordmarkProps {
    className?: string
    tone?: 'bark' | 'paper'
}

const Wordmark: FC<WordmarkProps> = ({ className, tone = 'bark' }): ReactNode => {
    return (
        <span className={cn('inline-flex items-baseline gap-2.5', tone === 'bark' ? 'text-bark' : 'text-paper', className)}>
            <span className='wonk font-heading text-[1.7rem] font-medium italic leading-none tracking-[-0.01em]'>
                Qog&rsquo;oz
            </span>
            <span className='relative -top-[0.1em] text-[0.82rem] font-medium opacity-80'>
                Atelier
            </span>
            <span aria-hidden='true' className='relative -top-[0.95em] -ml-1 size-[0.42rem] rounded-full bg-pomegranate' />
        </span>
    )
}

export default Wordmark
